import * as React from 'react';
import mergeIconUrl from '../../../assets/icon-node-connected.svg';
import { IconProps } from '../../typescriptHelpers';

const MergeIcon: React.FC<IconProps> = ({ width, height }: IconProps) => {
    return <img src={mergeIconUrl} width={width} height={height} />;
};

export default MergeIcon;
